import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ecbb8b66&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ecbb8b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbb8b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecbb8b66')) {
      api.createRecord('ecbb8b66', component.options)
    } else {
      api.reload('ecbb8b66', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ecbb8b66&scoped=true&", function () {
      api.rerender('ecbb8b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iFucYBrI3F5P/JS/teamMember.vue"
export default component.exports